import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchFacetDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'facet/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveFacet(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const facetData = {
    doc_type: DocType.FACET,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined)
  };
  return common.saveDoc(app, {
    source: data,
    doc: facetData,
    user
  });
}

export function deleteFacet(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.FACET
  });
}

export function fetchFacetById(app, params) {
  const { id } = params;
  const docType = DocType.FACET;
  return common.getDoc(app, { id, docType });
}
